import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const API = axios.create({
  baseURL: API_URL
});

API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export const authAPI = {
  register: (data) => API.post('/auth/register', data),
  login: (data) => API.post('/auth/login', data),
  getMe: () => API.get('/auth/me'),
  updateProfile: (data) => API.put('/auth/profile', data),
  updatePassword: (data) => API.put('/auth/password', data),
};

export const productsAPI = {
  getAll: (params) => API.get('/products', { params }),
  getOne: (id) => API.get(`/products/${id}`),
  getCategories: () => API.get('/products/meta/categories'),
  addReview: (id, data) => API.post(`/products/${id}/reviews`, data),
};

export const ordersAPI = {
  create: (data) => API.post('/orders', data),
  getMy: () => API.get('/orders/my'),
  getOne: (id) => API.get(`/orders/${id}`),
  pay: (id, data) => API.put(`/orders/${id}/pay`, data),
};

export const contactAPI = {
  submit: (data) => API.post('/contact', data),

  getAll: (params) => API.get('/contact/admin', { params }),
  getOne: (id) => API.get(`/contact/admin/${id}`),
  reply: (id, reply) =>
    API.post(`/contact/admin/${id}/reply`, { reply }),
  delete: (id) => API.delete(`/contact/admin/${id}`),
  updateStatus: (id, status) =>
    API.patch(`/contact/admin/${id}/status`, { status }),
};

export const adminAPI = {
  getStats: () => API.get('/admin/stats'),
  getProducts: () => API.get('/admin/products'),
  createProduct: (data) => API.post('/admin/products', data),
  updateProduct: (id, data) =>
    API.put(`/admin/products/${id}`, data),
  deleteProduct: (id) =>
    API.delete(`/admin/products/${id}`),
  getOrders: (params) =>
    API.get('/admin/orders', { params }),
  updateOrderStatus: (id, data) =>
    API.put(`/admin/orders/${id}/status`, data),
  getUsers: () => API.get('/admin/users'),
  toggleUser: (id) =>
    API.put(`/admin/users/${id}/toggle`),
};

export const promotionsAPI = {
  getAll: () => API.get('/promotions'),
  create: (data) => API.post('/promotions', data),
  delete: (id) => API.delete(`/promotions/${id}`),
  checkExpired: () => API.post('/promotions/check-expired'),
};

export default API;
// import axios from 'axios';

// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
// const API = axios.create({ baseURL: '/api' });

// API.interceptors.request.use(config => {
//   const token = localStorage.getItem('token');
//   if (token) config.headers.Authorization = `Bearer ${token}`;
//   return config;
// });

// API.interceptors.response.use(
//   res => res,
//   err => {
//     if (err.response?.status === 401) {
//       localStorage.removeItem('token');
//       localStorage.removeItem('user');
//       window.location.href = '/login';
//     }
//     return Promise.reject(err);
//   }
// );

// export const authAPI = {
//   register: (data) => API.post('/auth/register', data),
//   login: (data) => API.post('/auth/login', data),
//   getMe: () => API.get('/auth/me'),
//   updateProfile: (data) => API.put('/auth/profile', data),
//   updatePassword: (data) => API.put('/auth/password', data),
// };

// export const productsAPI = {
//   getAll: (params) => API.get('/products', { params }),
//   getOne: (id) => API.get(`/products/${id}`),
//   getCategories: () => API.get('/products/meta/categories'),
//   addReview: (id, data) => API.post(`/products/${id}/reviews`, data),
// };

// export const ordersAPI = {
//   create: (data) => API.post('/orders', data),
//   getMy: () => API.get('/orders/my'),
//   getOne: (id) => API.get(`/orders/${id}`),
//   pay: (id, data) => API.put(`/orders/${id}/pay`, data),
// };

// export const contactAPI = {
//   submit: (data) => API.post('/contact', data),
//   // admin
//   getAll: (params) => API.get('/contact/admin', { params }),
//   getOne: (id) => API.get(`/contact/admin/${id}`),
//   reply: (id, reply) => API.post(`/contact/admin/${id}/reply`, { reply }),
//   delete: (id) => API.delete(`/contact/admin/${id}`),
//   updateStatus: (id, status) => API.patch(`/contact/admin/${id}/status`, { status }),
// };


// export const adminAPI = {
//   getStats: () => API.get('/admin/stats'),
//   getProducts: () => API.get('/admin/products'),
//   createProduct: (data) => API.post('/admin/products', data),
//   updateProduct: (id, data) => API.put(`/admin/products/${id}`, data),
//   deleteProduct: (id) => API.delete(`/admin/products/${id}`),
//   getOrders: (params) => API.get('/admin/orders', { params }),
//   updateOrderStatus: (id, data) => API.put(`/admin/orders/${id}/status`, data),
//   getUsers: () => API.get('/admin/users'),
//   toggleUser: (id) => API.put(`/admin/users/${id}/toggle`),
// };


// export const promotionsAPI = {
//   getAll: () => API.get('/promotions'),
//   create: (data) => API.post('/promotions', data),
//   delete: (id) => API.delete(`/promotions/${id}`),
//   checkExpired: () => API.post('/promotions/check-expired'),
// };

// export default API;
